(() => {
  const hpNews = document.querySelector(".hp-news");
  const allNews = hpNews.querySelectorAll(".hp-news__list__item");

  const dataDotFix = () => {};

  const addIdLead = () => {
    allNews.forEach((news) => {
      const lead = news.querySelector(".desc");

      if (news !== allNews[0] && lead) {
        lead.setAttribute("data-dot", "3");
      }
    });
  };

  // callback is called on intersection change
  const onIntersection = (entries, opts) => {
    entries.forEach((entry) =>
      entry.target.classList.toggle("visible", entry.isIntersecting)
    );
  };

  const seeScroll = () => {
    let observer = new IntersectionObserver(onIntersection, {
      root: null, // default is the viewport
      threshold: 0.1, // percentage of target's visible area. Triggers "onIntersection"
    });

    observer.observe( hpNews );
    // observer.unobserve(entry.target);
  };

  const init = () => {
    if (hpNews) {
      dataDotFix();
      addIdLead();
      seeScroll();
    }
  };

  init();
})();
